import { Request } from '../../../components/Request';
import { BrowserNotification } from '../../../components/BrowserNotification';
import WindowSize from '../../../components/WindowSize';
import { WINDOW_SIZE_CHANGED_FINISH } from "./windowSize.js";

export const CHANGE_PREFERRED_GAMES_NAVIGATE = 'CHANGE_PREFERRED_GAMES_NAVIGATE';

export const CHANGE_PROFILE_SETTING_BEGIN = 'CHANGE_PROFILE_SETTING_BEGIN';
export const CHANGE_PROFILE_SETTING_SUCCESS = 'CHANGE_PROFILE_SETTING_SUCCESS';
export const CHANGE_PROFILE_SETTING_FAIL = 'CHANGE_PROFILE_SETTING_FAIL';

export const CHANGE_PLAYER_SETTING_BEGIN = 'CHANGE_PLAYER_SETTING_BEGIN';
export const CHANGE_PLAYER_SETTING_SUCCESS = 'CHANGE_PLAYER_SETTING_SUCCESS';
export const CHANGE_PLAYER_SETTING_FAIL = 'CHANGE_PLAYER_SETTING_FAIL';

export const SETTINGS_PAGE_BACK_TO_BEGINNING = 'SETTINGS_PAGE_BACK_TO_BEGINNING';
export const PLAYER_SETTING_UPDATE = 'PLAYER_SETTING_UPDATE';

export const CHEAT_CODE_ACTIVATED = 'CHEAT_CODE_ACTIVATED';
export const TOGGLE_SHOW_MAIN_CHAT_AS_POPUP = 'TOGGLE_SHOW_MAIN_CHAT_AS_POPUP';

export const TOGGLE_FORCE_CHAT_PLUS_MATCH_VIEW = 'TOGGLE_FORCE_CHAT_PLUS_MATCH_VIEW';
export const TOGGLE_SHOW_STREAM_VIEW_ALWAYS = 'TOGGLE_SHOW_STREAM_VIEW_ALWAYS';

export const toggleShowStreamViewTabEvenWhenNotStreaming = () => (dispatch) => {
	dispatch({
		type: TOGGLE_SHOW_STREAM_VIEW_ALWAYS
	});
	WindowSize._changeHappened(true);
};

const checkChatStyle = (isChecked) => {
	if(isChecked) {
		$('body').removeClass('chat_style_modern');
	}
	else {
		$('body').addClass('chat_style_modern');
	}
};

export const toggleShowMainChatAsPopup = () => {
	return {
		type: TOGGLE_SHOW_MAIN_CHAT_AS_POPUP
	};
};

export const toggleForceChatPlusMatchView = () => (dispatch) => {
	dispatch({
		type: TOGGLE_FORCE_CHAT_PLUS_MATCH_VIEW
	});
	WindowSize._changeHappened(true);
};

export const changePlayerSetting = (userSettingPath) => {
	return {
		type: PLAYER_SETTING_UPDATE,
		payload: userSettingPath
	};
};

const BROWSER_NOTIFICATION_SETTINGS = ['match_browser_notifications', 'pm_browser_notifications', 'receive_browser_notifications'];

const currentProfileSetting = (name) => (window.myUser && window.myUser.settings ? window.myUser.settings[name] : undefined);
const currentPlayerSetting = (name) => (window.myUser ? window.myUser[name] : undefined);

// Per setting: the number of the latest save, and the last value the server
// accepted. Saves can finish out of order, so only a failure of the latest
// save rolls back, and it rolls back to that accepted value.
const saveTracking = {};

function trackingFor(key, currentValue) {
	if(!saveTracking[key] || saveTracking[key].pending === 0) {
		saveTracking[key] = { latest: saveTracking[key] ? saveTracking[key].latest : 0, pending: 0, acceptedNumber: 0, acceptedValue: currentValue };
	}
	return saveTracking[key];
}

// Saves one setting through player/profile. BEGIN applies the value to myUser
// right away; FAIL (for the latest save) puts back the last accepted value, and
// is sent with a null payload when a later save superseded the failed one.
// Returns the save promise (the settings page shows "Saved" or an inline error)
// and rejects with the server response instead of alerting.
const saveSetting = (dispatch, { name, value, previousValue, beginType, successType, failType, onFail }) => {
	const tracking = trackingFor(`${beginType}:${name}`, previousValue);
	tracking.latest += 1;
	tracking.pending += 1;
	const saveNumber = tracking.latest;
	dispatch({ type: beginType, payload: { name, value, previousValue } });
	return Request.apiv1('player/profile', { [name]: value })
		.then((response) => {
			tracking.pending -= 1;
			if(saveNumber > tracking.acceptedNumber) {
				tracking.acceptedNumber = saveNumber;
				tracking.acceptedValue = value;
			}
			dispatch({ type: successType });
			return response;
		})
		.catch((failure) => {
			tracking.pending -= 1;
			if(saveNumber === tracking.latest) {
				dispatch({ type: failType, payload: { name, previousValue: tracking.acceptedValue } });
				if(onFail) {
					onFail(tracking.acceptedValue);
				}
			}
			else {
				dispatch({ type: failType, payload: null });
			}
			throw failure;
		});
};

export const updatePlayerSetting = (e) => (dispatch) => {
	const { name, checked, value } = e.target;
	return saveSetting(dispatch, {
		name,
		value: checked === undefined ? !!value : checked,
		previousValue: currentPlayerSetting(name),
		beginType: CHANGE_PLAYER_SETTING_BEGIN,
		successType: CHANGE_PLAYER_SETTING_SUCCESS,
		failType: CHANGE_PLAYER_SETTING_FAIL,
	});
};

export const updatePlayerProfileSettingValue = (e) => (dispatch) => {
	const { name, value } = e.target;
	return saveSetting(dispatch, {
		name,
		value,
		previousValue: currentProfileSetting(name),
		beginType: CHANGE_PROFILE_SETTING_BEGIN,
		successType: CHANGE_PROFILE_SETTING_SUCCESS,
		failType: CHANGE_PROFILE_SETTING_FAIL,
	});
};

export const updatePlayerProfileSetting = (e) => (dispatch) => {
	const { name, checked, value } = e.target;
	const changeTo = checked === undefined ? !!value : checked;
	const previousValue = currentProfileSetting(name);
	let onFail = null;
	if(name === 'compact_chat_style') {
		checkChatStyle(changeTo);
		$('.chat_holder.active .chat_container').each(function() {
			$(this).scrollTop($(this)[0].scrollHeight);
		});
		onFail = (restoredValue) => checkChatStyle(!!restoredValue);
	}
	if(BROWSER_NOTIFICATION_SETTINGS.includes(name) && changeTo) {
		// The toggle click is the user gesture the browser's prompt needs.
		BrowserNotification.requestPermissionAndSubscribe();
	}
	if(name === 'receive_browser_notifications' && !changeTo) {
		BrowserNotification.unsubscribe();
	}

	return saveSetting(dispatch, {
		name,
		value: changeTo,
		previousValue,
		beginType: CHANGE_PROFILE_SETTING_BEGIN,
		successType: CHANGE_PROFILE_SETTING_SUCCESS,
		failType: CHANGE_PROFILE_SETTING_FAIL,
		onFail,
	});
};

export const settingsChangePreferredGamesStart = (game) => {
	return {
		type: CHANGE_PREFERRED_GAMES_NAVIGATE,
		payload: game,
	};
};

export const settingsPageBackToStart = () => {
	return {
		type: SETTINGS_PAGE_BACK_TO_BEGINNING
	};
};

export const cheatCodeActivatedChange = (e) => {
	const { checked } = e.target;
	return {
		type: CHEAT_CODE_ACTIVATED,
		payload: checked
	};
};
